import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "./aws-exports";
import useAuth from "./hooks/useAuth";

import Dashboard from "../src/pages/Dashboard.js";
import SendedOrders from "./pages/sendedOrders";
import Login from "./pages/login/Login.js";
import NotFound from "./pages/notFound/notFound";

import GuardedRoute from "./components/guardedRoute";

Amplify.configure(awsconfig);

// >>New - Configuring Auth Module
Auth.configure(awsconfig);

function App() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const isAuth = currentUser !== null;

  return (
    <Routes>
      <Route index path="/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />
      <Route
        exact
        path="/"
        element={<GuardedRoute isAuth={isAuth} location={location} />}
      >
        <Route exact path="/home" element={<Dashboard />} />
        <Route exact path="/sended" element={<SendedOrders />} />
      </Route>
    </Routes>
  );
}

export default App;
